import '@src/styles/frontend.scss';
import '@src/scripts/init/react-habitat';
import { redirectThankYouPage } from '@util/redirects';
import {
	updateProductCode,
	updateWebsiteCode,
	updatePrefillForm,
} from '@src/scripts/util/prefillForms';

redirectThankYouPage();
updateProductCode();
updateWebsiteCode();
updatePrefillForm();
